import { Node } from "slate";
export function getText(elements) {
    let result = '';
    return (
        elements
            // Return the string content of each paragraph in the value's children.
            .map(n => Node.string(n))
            // Join them all with line breaks denoting paragraphs.
            .join('\n')
    )
    // elements?.forEach(element => {
    //     if (element.children) {
    //         result += getText(element.children);
    //     } else if (element.text !== undefined) {
    //         if (element.text === '') {
    //             result += '\n';
    //         } else {
    //             result += element.text;
    //         }
    //     }
    // });
    // return result;
}

export function getTextCount(elements) {
    let result = '';
    if(elements)
        elements?.forEach(element => {
            if (element?.children && element?.type !== 'tag') {
                result += getTextCount(element.children);
            } else if(element?.type === 'tag'){
                result += 'a';
            }else if (element?.text !== undefined) {
                if (element?.text === '') {
                    result;
                } else {
                    result += element?.text;
                }
            }
        });
    return result;
}
export const parseTextToSlate = (text) => {
    if (!!text){
        const texts= text.trim().split('\n')
        return texts.map((line, index) => {
            // Nếu dòng trống (sau khi trim) thì trả về đoạn rỗng

            if (line.trim() === '') {
                return { type: 'paragraph', children: [{ text: '' }] };
            }

            const parts = line.split(/(\{[^}]+\})/g); // Tách placeholder
            let children = parts
                .filter(Boolean) // bỏ các phần null/empty
                .map(part =>
                    /^\{[^}]+\}$/.test(part)
                        ? { type: 'tag', children:[{text: part}] }
                        : { text: part }
                );
            if(texts.length - 1 === index)
                children=[...children,{text:' '}]
            return { type: 'paragraph', children };
        });
    }

};

